export const branchUnmapped: string =
  'This lead has been submitted for a branch that does not have any sales teams associated with it. Set up a sales team for this branch to save it in Sales Center.'
